import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import SiderAction from '../SiderAction';

import { Container } from './PDFExport.styles';
import { colors } from '../../utils/variables.styles';
import { open } from '../../layout/components/Drawer/Drawer.reducer';
import {FilePdfOutlined} from "@ant-design/icons";

class PDFExport extends React.Component {
  static propTypes = {
    openForm: PropTypes.node,
    selectedVoivodeship: PropTypes.any,
    availableVoivodeship: PropTypes.array,
    selectedVoivodeshipObject: PropTypes.object,
  }

  static defaultProps = {
    openForm: null,
    translationsData: null,
    selectedVoivodeshipObject: null,
    availableVoivodeship: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedVoivodeshipObject: null,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedVoivodeship !== this.props.selectedVoivodeship) {

      const selectedObj = this.props.availableVoivodeship.find(voivo => voivo.id == this.props.selectedVoivodeship);

      this.setState({ selectedVoivodeshipObject: selectedObj });
    }
  }

  handleContainerClick = () => {
    const { selectedVoivodeshipObject } = this.state;
    const { openForm } = this.props;

    if (!selectedVoivodeshipObject) {
      alert( this.props.translationsData.please_select_voivodeship || 'please_select_voivodeship');
    } else {
      openForm('pdfExport');
    }
  }
  render() {

    return (
      <div style={{ color: colors.primaryFontColor }}>
        <Container collapsed={this.props.collapsed} onClick={() => { this.handleContainerClick() }}>
          <SiderAction
            icon={<FilePdfOutlined/>}
            collapsed={this.props.collapsed}
            pointer
            bottom
          >
            {this.props.translationsData. save_as_pdf || 'save_as_pdf'}
          </SiderAction>
        </Container>
      </div>
    );
  }
}

PDFExport.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

const mapDispatchToProps = {
  openForm: open
};

const mapStateToProps = (state) => ({
  selectedVoivodeship: state.Construction.selected.voivodeship,
  availableVoivodeship: state.Construction.available.voivodeship,
});

export default connect(mapStateToProps, mapDispatchToProps)(PDFExport);

